import {useMutation} from '@tanstack/react-query'
import {useGetCalendarApiMethod} from 'api/useGetCalendarApiMethod'
import {Params, Ventrata} from 'types'

export const useGetCalendarMutation = () => {
  const getCalendar = useGetCalendarApiMethod()

  return useMutation({
    mutationFn: async (
      params: Omit<Params.GetCalendar, 'optionId'> & {optionIds: string[]}
    ): Promise<Record<string, Ventrata.CalendarDay[]>> => {
      const calendars = await Promise.all(params.optionIds.map((optionId) => getCalendar({...params, optionId})))

      return params.optionIds.reduce<Record<string, Ventrata.CalendarDay[]>>((accumulator, optionId, index) => {
        accumulator[optionId] = calendars[index]
        return accumulator
      }, {})
    },
  })
}
